import { Entity } from '../types/UtilityTypes'
import { FailedResponse, SuccessResponse } from '../responses/response'
import { TypedAjaxResponse } from '../http/types'

export const isEntity = (x: unknown): x is Entity => x ?
    typeof x === 'object' && Object.prototype.hasOwnProperty.call(x, 'id') :
    false

export const isEntityArray = (x: unknown): x is Entity[] => {
    if (!Array.isArray(x)) {
        return false
    }
    if (x.length === 0) {
        return true
    }
    return isEntity(x[0])
}

export const isSimpleType = (x: unknown): x is string | number => {
    return ['string', 'number', 'undefined', 'boolean'].includes(typeof x) || x === null
}

export const isSuccess = <T extends SuccessResponse>(res: FailedResponse | T): res is T => res.success
export const isFailure = <T extends SuccessResponse>(res: FailedResponse | T): res is FailedResponse => !res.success
export const isSuccessArray = <T extends SuccessResponse>(responses: TypedAjaxResponse<FailedResponse | T>[]): responses is TypedAjaxResponse<T>[] =>
    responses.map(res => res.response).every(isSuccess)

export const isHtmlElement = (element: unknown): element is HTMLElement => element instanceof HTMLElement